export default "__VITE_ASSET__BccZLwoS__"